import { withHook } from 'utils/withHook';
import { useNewsArticleState } from 'containers/NewsArticle/logic/useNewsArticleState';
import { NewsArticleView } from 'containers/NewsArticle/view/NewsArticleView';

export const NewsArticle = withHook(useNewsArticleState)(NewsArticleView);
